<template>
  <v-container fluid>
    <v-card class="mx-auto" max-width="1200" elevation="3">

      <!-- Exibe spinner enquanto os dados estão sendo carregados -->
      <v-overlay :value="isLoading" opacity="0.8" z-index="5">
        <v-progress-circular indeterminate size="64" color="primary" />
      </v-overlay>

      <!-- Filtro de ano lectivo -->
      <v-card-title class="py-4">
        <v-select
          v-model="anoLectivoSelected"
          :items="anoLectivos"
          item-text="novadescricao"
          item-value="anolectivo"
          label="Filtrar por Ano Lectivo"
          outlined dense hide-details
          class="mr-4"
          style="max-width: 300px"
        />
      </v-card-title>

      <v-divider />

      <!-- Tabela de emolumentos -->
      <v-data-table
        :headers="headers"
        :items="filteredEmolumentos"
        :loading="isLoading"
        loading-text="Carregando dados..."
        no-data-text="Nenhum emolumento encontrado"
        class="elevation-1"
      >
        <!-- Status: Ativo ou Desativado -->
        <template v-slot:item.status_="{ item }">
          <v-chip :color="item.status_ == 1 ? 'success' : 'error'" small dark>
            {{ item.status_ == 1 ? "Ativo" : "Desativado" }}
          </v-chip>
        </template>

        <!-- Ícone indicando se o preço é igual por período -->
        <template v-slot:item.precoPorPeriodo="{ item }">
          <v-icon :color="item.precoPorPeriodo == 1 ? 'success' : 'error'">
            {{ item.precoPorPeriodo == 1 ? "mdi-check" : "mdi-close" }}
          </v-icon>
        </template>

        <!-- Botão para abrir registros associados -->
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click.stop="abrirRegistroAssociado(item)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Ver registros associados</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";
import axios from "../../plugins/axios";
import utilitarios from "../../plugins/utilitarios";
const ls = require("local-storage");

export default {
  data() {
    return {
      headers: [
        { text: "ID", value: "id", width: "100px" },
        { text: "Descrição", value: "descricao" },
        { text: "Descrição Reduzida", value: "descricaoReduzida" },
        { text: "Mesmo Preço Por Período", value: "precoPorPeriodo", align: "center" },
        { text: "Estado", value: "status_", align: "center" },
        { text: "Autor", value: "autor" },
        { text: "Ações", value: "action", sortable: false, align: "center", width: "100px" },
      ],
      emolumentosAll: [],
      anoLectivos: [],
      anoLectivoSelected: null,
      isLoading: false,
      utilitarios,
    };
  },

  computed: {
    anolectivo() {
      return ls.get("anolectivo");
    },
    // Filtra os dados pelo ano letivo selecionado
    filteredEmolumentos() {
      if (!this.anoLectivoSelected) return this.emolumentosAll;
      return this.emolumentosAll.filter(e => e.anolectivo == this.anoLectivoSelected);
    },
  },

  created() {
    this.carregarEmolumentos();
    this.carregarAnosLectivos();
  },

  methods: {
    async carregarEmolumentos() {
      this.isLoading = true;
      try {
        const { data } = await axios.get("getAllEmolumentos");
        this.emolumentosAll = data;
      } catch (error) {
        Swal.fire("Erro", "Erro ao carregar os emolumentos!", "error");
      } finally {
        this.isLoading = false;
      }
    },

    async carregarAnosLectivos() {
      this.isLoading = true;
      try {
        const { data } = await axios.get("getAnosLectivosEmolumentos");
        this.anoLectivos = data;

        if (data.length) {
          const atual = this.anolectivo;
          const encontrado = data.find(a => a.anolectivo == atual);
          this.anoLectivoSelected = encontrado ? encontrado.anolectivo : data[0].anolectivo;
        }
      } catch (error) {
        Swal.fire("Erro", "Erro ao carregar os anos lectivos!", "error");
      } finally {
        this.isLoading = false;
      }
    },

    abrirRegistroAssociado(item) {
      this.$store.state.idEmolumento = item.id;
      this.$store.state.anoSelected = item.anolectivo;
      this.$router.push("registrosAssociados");
    },
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 8px;
}

.v-data-table {
  border-radius: 0 0 8px 8px;
}
</style>
